var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 203,
    viewBox: "0 0 360 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.499 190.574L247.191 203L360 203V170.5L312.5 143L227.499 190.574Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 134.5L214 180L59 89.5L140 42L300 134.5Z",
    fill: "#E5F7F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226 203H112.5H-1V68.5L226 203Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 129.9C225.658 129.9 227.418 129.188 227.418 128.309C227.418 127.431 225.658 126.719 223.488 126.719C221.317 126.719 219.558 127.431 219.558 128.309C219.558 129.188 221.317 129.9 223.488 129.9Z",
    fill: "#192643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.85 108.004C229.85 113.65 226.17 118.453 223.394 118.453C220.618 118.453 217 114.086 217 108.441C217 102.796 220.618 94 223.394 94C226.17 94 229.85 102.359 229.85 108.004Z",
    fill: "#192643"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 99.6143V128.465",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 104.885L223.488 109.844",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 101.143L223.425 106.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 108.129L223.425 113.12",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 111.436L223.488 116.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M222.24 128.153C222.24 128.153 223.675 128.902 224.735 128.153",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 90.9002C146.658 90.9002 148.418 90.188 148.418 89.3095C148.418 88.4309 146.658 87.7188 144.488 87.7188C142.317 87.7188 140.558 88.4309 140.558 89.3095C140.558 90.188 142.317 90.9002 144.488 90.9002Z",
    fill: "#192643"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.85 69.0044C150.85 74.6498 147.17 79.4531 144.394 79.4531C141.618 79.4531 138 75.0865 138 69.4411C138 63.7956 141.618 55 144.394 55C147.17 55 150.85 63.359 150.85 69.0044Z",
    fill: "#192643"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 60.6143V89.4652",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 65.8853L144.488 70.8445",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 62.1426L144.425 67.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 69.1294L144.425 74.1198",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 72.4355L144.488 77.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 89.1533C143.24 89.1533 144.675 89.9019 145.735 89.1533",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M213.065 116.688C209.314 116.688 206.273 115.458 206.273 113.939C206.273 112.421 209.314 111.19 213.065 111.19C216.815 111.19 219.856 112.421 219.856 113.939C219.856 115.458 216.815 116.688 213.065 116.688Z",
    fill: "#192643"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M215.216 113.674C215.216 113.674 212.737 114.968 210.904 113.674",
    stroke: "#00B0A6",
    strokeWidth: 2.081,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 133.237V108.119L206 94.7646L191.501 119.882V150L220.5 133.237Z",
    fill: "#00B0A6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M191.499 119.881L205.998 94.763L154.5 65L140 90L191.499 119.881Z",
    fill: "#192643"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M191.505 119.885L140 89.8823V120L191.505 150.003V119.885Z",
    fill: "#018289"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 123.215V142.565L211.067 138.684V119.334L204.384 123.215Z",
    fill: "#192643"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 123.208L173.28 119.328V130.916L179.964 134.797V123.208Z",
    fill: "#192643"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 142.564L211.067 138.684L204.384 134.372V142.564Z",
    fill: "#101627"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 134.797L173.28 130.917L179.964 126.604V134.797Z",
    fill: "#101627"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 108.208L148.28 104.328V115.916L154.964 119.797V108.208Z",
    fill: "#192643"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 119.797L148.28 115.917L154.964 111.604V119.797Z",
    fill: "#101627"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.5 33L48.5 80L-0.5 50.5V0H63.5L129.5 33Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.873 130.516C129.606 130.586 129.446 130.86 129.516 131.127L130.656 135.48C130.726 135.747 131 135.907 131.267 135.837C131.534 135.767 131.694 135.494 131.624 135.226L130.61 131.357L134.48 130.344C134.747 130.274 134.907 130 134.837 129.733C134.767 129.466 134.494 129.306 134.226 129.376L129.873 130.516ZM183.127 162.484C183.394 162.414 183.554 162.14 183.484 161.873L182.344 157.52C182.274 157.253 182 157.093 181.733 157.163C181.466 157.233 181.306 157.506 181.376 157.774L182.39 161.643L178.52 162.656C178.253 162.726 178.093 163 178.163 163.267C178.233 163.534 178.506 163.694 178.774 163.624L183.127 162.484ZM129.748 131.432L182.748 162.432L183.252 161.568L130.252 130.568L129.748 131.432Z",
    fill: "#192643"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M126.4 116.2C126.4 124.594 119.594 131.4 111.2 131.4C102.806 131.4 96 124.594 96 116.2C96 107.806 102.806 101 111.2 101C119.594 101 126.4 107.806 126.4 116.2Z",
    fill: "#192643",
    stroke: "#00B0A6",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.008 120H116.332L112.412 110.382H110.102L106.182 120H108.492L109.108 118.488H113.392L114.008 120ZM109.822 116.738L111.25 113.224L112.678 116.738H109.822Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M205.516 162.08C205.447 162.348 205.609 162.62 205.876 162.689L210.236 163.802C210.504 163.87 210.776 163.709 210.845 163.441C210.913 163.173 210.751 162.901 210.484 162.833L206.608 161.843L207.598 157.968C207.666 157.7 207.504 157.428 207.237 157.359C206.969 157.291 206.697 157.453 206.629 157.72L205.516 162.08ZM235.484 145.124C235.553 144.856 235.391 144.584 235.124 144.516L230.764 143.403C230.496 143.334 230.224 143.496 230.155 143.763C230.087 144.031 230.249 144.303 230.516 144.372L234.392 145.361L233.402 149.237C233.334 149.504 233.496 149.777 233.763 149.845C234.031 149.913 234.303 149.752 234.371 149.484L235.484 145.124ZM206.255 162.634L235.255 145.43L234.745 144.57L205.745 161.774L206.255 162.634Z",
    fill: "#192643"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M273.4 128.2C273.4 136.594 266.594 143.4 258.2 143.4C249.806 143.4 243 136.594 243 128.2C243 119.806 249.806 113 258.2 113C266.594 113 273.4 119.806 273.4 128.2Z",
    fill: "#192643",
    stroke: "#00B0A6",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M255.036 133H260.09C261.924 133 263.24 131.936 263.24 130.396C263.24 129.332 262.596 128.436 261.476 127.932C262.33 127.484 262.82 126.77 262.82 125.79C262.82 124.39 261.63 123.382 259.908 123.382H255.036V133ZM257.094 127.26V125.146H259.39C260.16 125.146 260.706 125.594 260.706 126.196C260.706 126.812 260.16 127.26 259.39 127.26H257.094ZM257.094 131.236V128.884H259.712C260.538 128.884 261.126 129.374 261.126 130.06C261.126 130.746 260.538 131.236 259.712 131.236H257.094Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M304.333 54.3055C304.333 72.231 289.801 86.7638 271.875 86.7638C253.95 86.7638 239.417 72.231 239.417 54.3055C239.417 36.38 253.95 21.8472 271.875 21.8472C289.801 21.8472 304.333 36.38 304.333 54.3055Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M300.917 51.4583C300.917 69.3839 286.384 83.9167 268.458 83.9167C250.533 83.9167 236 69.3839 236 51.4583C236 33.5328 250.533 19 268.458 19C286.384 19 300.917 33.5328 300.917 51.4583Z",
    fill: "#152954"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7014_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.676 59.4955L287.805 63.034M276.496 40.161L280.034 34.0322L276.496 40.161ZM258.803 70.805L262.342 64.6762L258.803 70.805Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5 40.9188L261.931 58.3106L262.465 48.4044L270.777 42.9886L249.5 40.9188Z",
    fill: "#00B0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.324 38.0269L261.647 38.5446C266.384 35.9024 272.35 35.7247 277.38 38.6289C284.983 43.0184 287.599 52.7759 283.208 60.3802C278.818 67.9845 269.06 70.5979 261.457 66.2085C256.427 63.3043 253.598 58.0489 253.518 52.624L250.409 48.2727C248.659 56.3233 252.18 64.9383 259.688 69.2729C268.981 74.6381 280.908 71.4422 286.273 62.1495C291.638 52.8567 288.442 40.9297 279.149 35.5645C271.642 31.2299 262.421 32.4884 256.324 38.0269Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7014_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(261 21) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step_2.5c8b35b7da5fdbe99959cb90b35ef444.svg";
export { ForwardRef as ReactComponent };